export default __webpack_public_path__ + "static/media/ContestRank2.88f2591f.svg";